export const SESSION_KEYS = {
  /** Flag to prevent auto-login loop after logout */
  LOGOUT_IN_PROGRESS: 'logout_in_progress',
} as const;

/** WHY: Single source of truth for model options used in ExtractionForm and BatchProcessing */
export const MODEL_OPTIONS = [
  // Gemini 2.5 retired 2026-10-20; Llama 4 / GPT-5.x / Nova Premier removed 2026-10-13 (legacy, not supported by extraction-ai any more).
  { value: 'gemini-3.1-flash-lite', label: 'Gemini 3.1 Flash Lite (Default)' }, // The fastest, cost-efficient version
  { value: 'gemini-3.5-flash-lite', label: 'Gemini 3.5 Flash Lite' },
  { value: 'gemini-3.5-flash', label: 'Gemini 3.5 Flash' },
  { value: 'gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro (preview)' }, // The most powerful model

  { value: 'amazon.nova-pro-v1:0', label: 'Nova Pro' },
  { value: 'us.amazon.nova-lite-v1:0', label: 'Nova Lite' },
  { value: 'us.anthropic.claude-sonnet-4-6', label: 'Sonnet 4.6' },
  { value: 'us.anthropic.claude-haiku-4-5-20251001-v1:0', label: 'Haiku 4.5' },
  { value: 'us.anthropic.claude-haiku-5-5', label: 'Haiku 5.5' },
  { value: 'us.anthropic.claude-sonnet-5-5', label: 'Sonnet 5.5' },
  { value: 'us.anthropic.claude-opus-5-5', label: 'Opus 5.5' },
  { value: 'textract-analyze-document', label: 'AWS Textract (only for consent)' },
] as const;

export const DEFAULT_MODEL_NAME = 'gemini-3.1-flash-lite';

/** Consent extraction uses the same list (Llama/GPT legacy entries were removed 2026-10-13) */
export const CONSENT_MODEL_OPTIONS = MODEL_OPTIONS;

/** WHY: Eliminates hardcoded S3 path duplication across BatchProcessing */
export const S3_BUCKET_PREFIX = 's3://verif-y-ai-storage-dev/sample pdfs/';
